import { Button, Input, styled } from "@100mslive/react-ui";

import { ROLES } from "../../common/roles";
import React from "react";
import { isStreamingKit } from "../../common/utils";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const PreviewName = ({ name, onChange, onJoin, enableJoin }) => {
  const { role: userRole } = useParams(); // from the url
  const { t } = useTranslation();

  const formSubmit = e => {
    e.preventDefault();
  };
  const isTranslator = userRole === ROLES.E_V || userRole === ROLES.F_V;
  return (
    <Form onSubmit={formSubmit}>
      <Input
        required
        id="name"
        css={{ w: "100%" }}
        value={name}
        onChange={e => onChange(e.target.value)}
        placeholder={t("lbl_enter_name")}
        autoFocus
        autoComplete="name"
        disabled={true}
      />
      <Button type="submit" disabled={!name || !enableJoin} onClick={onJoin}>
        {t(isStreamingKit() ? "lbl_join_conference" : "lbl_join_room")}
      </Button>
    </Form>
  );
};

const Form = styled("form", {
  width: "100%",
  display: "flex",
  alignItems: "center",
  gap: "$4",
  mt: "$10",
  mb: "$10",
});

export default PreviewName;
